import Calendar from '../../Calendar/Calendar';

export const ClientCalendar = () => {
  return <Calendar />;
};
